<table mat-table [dataSource]="descriptions" class="barcodeTable">
  <ng-container matColumnDef="description">
    <th mat-header-cell *matHeaderCellDef>Название</th>
    <td mat-cell *matCellDef="let brand">{{ brand.description }}</td>
  </ng-container>
  <ng-container matColumnDef="menu">
    <th mat-header-cell *matHeaderCellDef>
      <button mat-icon-button (click)="openDescriptionDialog()">
        <mat-icon>add</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let brand">
      <button mat-icon-button color="warn" (click)="deleteDescription(brand)">
        <mat-icon>remove</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
  <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
</table>
